import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: "We were skeptical about a 1% listing fee, assuming we'd get less service. We were completely wrong. The photography was magazine quality, the communication was constant, and we saved over $18,000. They negotiated a full-price offer in 4 days.",
    name: 'Sarah & Michael T.',
    city: 'Scottsdale, AZ'
  }, {
    quote: "I've sold three homes in the past using traditional 3% agents. The experience with One Percent Listing AZ was actually superior. Their marketing strategy was aggressive and modern. I'll never pay traditional commissions again.",
    name: 'David R.',
    city: 'Paradise Valley, AZ'
  }, {
    quote: 'From the initial consultation to closing, everything was handled with incredible professionalism. They helped us price it perfectly and managed multiple offers. We kept $12,500 more of our equity than we would have with our last agent.',
    name: 'Jessica M.',
    city: 'Gilbert, AZ'
  }];
  return <section className="py-20 md:py-32 bg-white" data-id="element-298">
      <div className="container mx-auto px-4 md:px-6" data-id="element-299">
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24" data-id="element-300">
          <p className="text-gold text-xs font-bold tracking-[0.2em] uppercase mb-4" data-id="element-301">
            What Sellers Say
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal leading-tight" data-id="element-302">
            Real sellers. Real savings. Real results.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-16" data-id="element-303">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-cream p-8 md:p-10 border border-gold/20 rounded-sm relative flex flex-col" data-id="element-304">
              <div className="flex gap-1 mb-6" data-id="element-305">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-306" />)}
              </div>
              <span className="absolute top-6 right-8 font-serif text-6xl text-brick-red/20 leading-none" data-id="element-307">
                "
              </span>
              <p className="text-charcoal leading-relaxed mb-8 flex-grow relative z-10" data-id="element-308">
                "{testimonial.quote}"
              </p>
              <div className="w-12 h-[1px] bg-gold/30 mb-6" data-id="element-309" />
              <div data-id="element-310">
                <p className="font-serif text-lg text-charcoal" data-id="element-311">
                  {testimonial.name}
                </p>
                <p className="text-xs text-gold uppercase tracking-wider mt-1" data-id="element-312">
                  {testimonial.city}
                </p>
              </div>
            </div>)}
        </div>

        {/* Trust Logos Placeholder */}
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-50 grayscale" data-id="element-313">
          <span className="font-serif text-xl font-bold text-muted-foreground" data-id="element-314">
            MLS
          </span>
          <span className="font-sans text-lg font-bold text-muted-foreground" data-id="element-315">
            realtor.com
          </span>
          <span className="font-sans text-lg font-bold text-muted-foreground" data-id="element-316">
            Zillow Premier Agent
          </span>
          <span className="font-sans text-lg font-bold text-muted-foreground" data-id="element-317">
            BBB Accredited
          </span>
        </div>
      </div>
    </section>;
}